module.exports = __webpack_public_path__ + "static/img/9.0f5072d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/9.png
// module id = NOGS
// module chunks = 4